enum FixedTermMaturityActionType {
    Reinvest = "REINVEST",
    Withdrawal = "WITHDRAWAL"
}
export default FixedTermMaturityActionType